import { useNavigate, useSearchParams } from "react-router-dom";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import { useSnackbar } from "../../../context/popup";
import { useLoading } from "../../../components/Loading";
import { CardContent, CardHeader, FormControl, FormControlLabel, FormHelperText, Grid2, IconButton, Stack, Switch } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialSelect from "../../../components/MasterSelect";
import { useWorkflowBindingFormHandling } from "./components/WorkflowBindingStateHandle.js";
import MaterialInput from "../../../components/MaterialInput/index.js";
import MaterialBox from "../../../components/MaterialBox/index.js";
import MaterialButton from "../../../components/MaterialButton/index.js";
import { useEffect, useState } from "react";
import { fetchData } from "../../../services/index.js";
import DropDownConfig from "../../Utils/DropDownConfig.js";

const WorkflowBindingForm = () => {

    const [searchParams] = useSearchParams();
    const workflowDictionaryId = searchParams.get("id");
    const pageType = searchParams.get("pageType");
    const pageMode = pageType === "view" ? "view" : pageType === "edit" ? "edit" : "add";
    const navigate = useNavigate();
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();

    const [workflowStepOptions, setWorkflowStepOptions] = useState([]);
    const [bindingTypeOptions, setBindingTypeOptions] = useState([]); 
    const [bindingOptions, setBindingOptions] = useState([]);    
    const [environmentOptions, setEnvironmentOptions] = useState([]);
    
    useEffect(() => {
        if(pageMode === "view"){
            return
        }
        fetchAllDropdowns();
    }, []);

    //all dropdown api function
    const fetchAllDropdowns = async () => {
        setCircleLoading(true);

        try {
            const [
            workflowResponse,
            bindingTypeResponse,
            bindingResponse,
            environmentResponse
            ] = await Promise.allSettled([
            fetchData(`/reference/orchestration/work-flow-steps?dropdown=true&isActive=true`),
            fetchData(`/orchestration/key-value-store?code=${DropDownConfig.operationBindingType}&dropdown=true&isActive=true`),
            fetchData(`/api-engine/api-operation&dropdown=true&isActive=true`),
            fetchData(`/orchestration/key-value-store?code=${DropDownConfig.apiEnvironment}&dropdown=true&isActive=true`)
            ]);
            
            const formattedWorkflowSteps = workflowResponse?.value?.data?.items?.map((item) => ({
                value: item?.id,
                label: item?.keyName,
            })) || [];

            const formattedBindingTypes = bindingTypeResponse?.value?.data?.items?.map((item) => ({
                value: item?.id,
                label: item?.keyName
            })) || [];

            const formattedBindings = bindingResponse?.value?.data?.items?.map((item) => ({
                value: item?.id,
                label: item?.keyName,
            })) || [];

            const formattedEnvOptions = environmentResponse?.value?.data?.items?.map((item) => ({
                value: item?.id,
                label: item?.keyName,
            })) || [];
            
            setWorkflowStepOptions(formattedWorkflowSteps);
            setBindingTypeOptions(formattedBindingTypes);
            setBindingOptions(formattedBindings);
            setEnvironmentOptions(formattedEnvOptions);

        } catch (error) {
            console.error("Error fetching dropdown data:", error);
            showSnackbar("Error Fetching Dropdown","warning");
        } finally {
            setCircleLoading(false);
        }
    };
    const { formData, setFormData, handleChange, checkAllFields } = useWorkflowBindingFormHandling(); 
  return (
    <DashboardLayout>
        <CardHeader
        title={
            <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            >
                <Stack direction="row" alignItems="center" spacing={1}>
                    <IconButton onClick={() => navigate("/operation/workflow-binding")}>
                        <ArrowBack />
                    </IconButton>
                    <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                        Workflow Binding Details
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                        Enter New Workflow Binding Details.
                    </MaterialTypography>
                    </Stack>
                </Stack>
            </Stack>
        }
        />
        <CardContent>
            <Grid2 container spacing={1}>
                <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                    <MaterialTypography component="label" variant="caption" fontWeight="bold">
                        Workflow Step*
                    </MaterialTypography>
                    <MaterialSelect
                    name="workflowStepId"
                    value={formData.workflowStepId}
                    onChange={handleChange}
                    // options={workflowOptions}
                    success={formData.workflowStepIdStatus === "success"}
                    error={formData.workflowStepIdStatus === "error"}
                    isDisabled={pageMode === "view"}
                    />
                </Grid2> 
                <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                    <MaterialTypography component="label" variant="caption" fontWeight="bold">
                        Binding Type*
                    </MaterialTypography>
                    <MaterialSelect
                    name="bindingTypeId"
                    value={formData.bindingTypeId}
                    onChange={handleChange}
                    options={bindingTypeOptions}
                    success={formData.bindingTypeIdStatus === "success"}
                    error={formData.bindingTypeIdStatus === "error"}
                    isDisabled={pageMode === "view"}
                    />
                </Grid2>
                <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                    <MaterialTypography component="label" variant="caption" fontWeight="bold">
                        Binding*
                    </MaterialTypography>
                    <MaterialSelect
                    name="bindingId"
                    value={formData.bindingId}
                    onChange={handleChange}
                    // options={bindingOptions}
                    success={formData.bindingIdStatus === "success"}
                    error={formData.bindingIdStatus === "error"}
                    isDisabled={pageMode === "view"}
                    />
                </Grid2>
                <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                    <MaterialTypography component="label" variant="caption" fontWeight="bold">
                        Environment*
                    </MaterialTypography>
                    <MaterialSelect
                    name="environmentId"
                    value={formData.environmentId}
                    onChange={handleChange}
                    // options={environmentOptions}
                    success={formData.environmentIdStatus === "success"}
                    error={formData.environmentIdStatus === "error"}
                    isDisabled={pageMode === "view"}
                    />
                </Grid2>
                <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Binding Configuration*
                  </MaterialTypography>
                <MaterialInput
                  name="bindingConfig"
                  placeholder={`eg. {    "url": "https://example.com/api",
            "retries": 3
        }`}
                  value={formData.bindingConfig}
                  onChange={handleChange}
                  error={formData.bindingConfigStatus === "error" ? true : false}
                  success={formData.bindingConfigStatus === "success" ? true : false}
                  multiline
                  rows={3}
                />
                {formData.bindingConfigStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Binding Configuration should be maximum 20 characters long and can contain
                      only alphabets
                    </FormHelperText>
                  </FormControl>
                )}
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 4 }}>
                    <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                    >
                        Actve
                    </MaterialTypography>
                    <FormControlLabel
                    control={
                        <Switch
                        checked={formData.isActive}
                        onChange={(e) =>
                            handleChange({
                            target: {
                                name: "isActive",
                                value: e.target.checked,
                            },
                            })
                        }
                        disabled={pageMode === "view"}
                        color="primary"
                        />
                    }
                    label={
                        <MaterialTypography variant="caption" fontWeight="bold">
                        {formData.isActive ? "Yes" : "No"}
                        </MaterialTypography>
                    }
                    sx={{ marginLeft: 0 }}
                    />
                </Grid2>           
            </Grid2>
        </CardContent>
        <MaterialBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        >
            {pageMode !== "view" && (
            <>
                <MaterialButton
                sx={{ m: 2 }}
                variant="outlined"
                color="dark"
                onClick={() => navigate("/operation/workflow-binding")}
                >
                Cancel
                </MaterialButton>
                <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                // onClick={handleSubmitWorkflowBinding}
                >
                {pageMode === "edit" ? "Update" : "Submit"}
                </MaterialButton>
            </>
            )}
        </MaterialBox>
    </DashboardLayout>
  )
}

export default WorkflowBindingForm